import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/primeng';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kv-loyalty-info-customers-filter',
  templateUrl: 'loyalty-info-customers-filter.component.html',
  styles: [`
      .card .search-toolbar-input {
        display: flex;
        align-items: baseline;
      }
      label.required:after {
        top: 0
      }
  `]
})
export class LoyaltyInfoCustomersFilterComponent implements OnInit {

  @Output() onApply: EventEmitter<any> = new EventEmitter();

  nationItems: {value: string, label: string}[] = [{value: 'IT', label: 'IT'}]
  showSearchCard = false;
  searchForm: FormGroup;
  commonAllString: string;
  nations = [ 'FR', 'GR', 'EN' ];
  invalidSubmit = true;
  today: Date = new Date();

  constructor(
    private fb: FormBuilder,
    private srvNotify: MessageService
  ) {
    this.searchForm = this.fb.group( {
      'nation': new FormControl('IT'),
      'name': new FormControl(null),
      'surname': new FormControl( null),
      'mobile': new FormControl(null),
      'telephone': new FormControl(null),
      'email': new FormControl(null),
      'date_birth': new FormControl(null)
    })
  }

  ngOnInit(): void {
    this.nations.forEach(n => {
      this.nationItems.push({
        value: n,
        label: n
      });
    })
  }

  resetFilters() {
    this.searchForm = this.fb.group({
      'nation': new FormControl('IT'),
      'name': new FormControl(null),
      'surname': new FormControl( null),
      'mobile': new FormControl(null),
      'telephone': new FormControl(null),
      'email': new FormControl(null),
      'date_birth': new FormControl(null)
    })
  }

  search(data) {
    // if (!!this.searchForm.get('name') && this.searchForm.get('name').value !== '' && this.searchForm.get('name').value !== null
    //   && !!this.searchForm.get('surname') && this.searchForm.get('surname').value !== '' && this.searchForm.get('surname').value !== null
    //     || !!this.searchForm.get('email') && this.searchForm.get('email').value !== '' && this.searchForm.get('email').value !== null
    //      || !!this.searchForm.get('mobile') && this.searchForm.get('mobile').value !== '' && this.searchForm.get('mobile').value !== null
    //       || !!this.searchForm.get('date_birth') && this.searchForm.get('date_birth').value !== '' && this.searchForm.get('date_birth').value !== null ) {
            // console.log(this.searchForm.value);
            // this.onApply.emit(this.searchForm.value);
    // } else {
    //   this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Selezionare i campi necessari'});
    // }
    console.log(this.searchForm.value);
    this.onApply.emit(this.searchForm.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-info-customers/loyalty-info-customers-filter.component.ts